import { useQuery } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import getAuthConfig from '../requests/getAuthConfig';

export const useGetAuthConfig = (options?: {
  onError?: (error: unknown) => void;
}) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.authConfig],
    queryFn: getAuthConfig,
    ...options,
  });
